//  @flow
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router';
import type { State } from 'types/redux';
import { injectIntl } from 'react-intl';

// Components
import SidebarMenu from './SidebarMenu';

// Actions
import { goTo } from 'store/reducers/navigation/actions';
import { gtmUserEvent } from 'store/reducers/gtm/actions';
import { getCountryStates } from 'store/reducers/states/actions';

// Selectors
import { currentPath as getCurrentPath } from 'store/reducers/navigation/selectors';
import { isLoggedIn } from 'store/reducers/user/selectors';
import {
  getContactInfoProperty,
  getPhoneNumber
} from 'store/reducers/user/personInfo/selectors';
import { getHideProfile } from 'store/reducers/dealerSettings/selectors';

const mapStateToProps = (state: State) => ({
  currentPath: getCurrentPath(state),
  isLoggedIn: isLoggedIn(state),
  getPhoneNumber: getPhoneNumber(state),
  phonePrivacyPreference: getContactInfoProperty(
    state,
    'phonePrivacyPreference'
  ),
  textPrivacyPreference: getContactInfoProperty(state, 'textPrivacyPreference'),
  emailAddress: getContactInfoProperty(state, 'emailAddress'),
  emailPrivacyPreference: getContactInfoProperty(
    state,
    'emailPrivacyPreference'
  ),
  hideProfile: getHideProfile(state)
});

export default compose(
  withRouter,
  injectIntl,
  connect(
    mapStateToProps,
    {
      goTo,
      gtmUserEvent,
      getCountryStates
    }
  )
)(SidebarMenu);



// WEBPACK FOOTER //
// ./src/components/pages/User/Sidebar/SidebarMenu/SidebarMenuContainer.js